import Link from "next/link";
import type { ServiceOffering } from "@/types/services";

export function ServiceCtas({
  offering,
  className = "",
}: {
  offering: ServiceOffering;
  className?: string;
}) {
  const bookingHref = offering.bookingSlug ? `/booking/${offering.bookingSlug}` : null;
  const extraHref = offering.ctaUrl || null;
  if (!bookingHref && !extraHref) return null;

  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      {bookingHref ? (
        <Link
          href={bookingHref}
          className="inline-flex min-h-[44px] items-center justify-center rounded-[var(--border-radius)] bg-[var(--color-primary)] px-4 py-2 text-sm font-medium text-white hover:opacity-90"
        >
          Book this service
        </Link>
      ) : null}
      {extraHref ? (
        <Link
          href={extraHref}
          className="inline-flex min-h-[44px] items-center justify-center rounded-[var(--border-radius)] border border-[var(--color-border)] px-4 py-2 text-sm font-medium text-[var(--color-text)] hover:bg-[var(--color-surface-muted)]"
        >
          {offering.ctaLabel || "Learn more"}
        </Link>
      ) : null}
    </div>
  );
}
